import {tooltipClasses, type TooltipProps} from '@mui/material/Tooltip';
import {styled, Tooltip} from '@mui/material';

export const NoMaxWidthTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
  },
});
